import NotificationListTable from "@/app/shared/settings/notifications/list/table";
import { Notification } from "@/types";
import { useState, useEffect } from "react";
import ServicePageHeader from "./page-header";
import { fetchNotification } from "@/server/api-services";

export default function NotificationListPage() {
    const [notifications, setNotifications] = useState([] as Notification[]);

    useEffect(() => {
        loadNotifications();
    }, []);

    async function loadNotifications() {
        const response = await fetchNotification();

        

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Notification[];

        setNotifications(data);
    }

    const refresh = () => loadNotifications();

    return (
        <>
            <ServicePageHeader title="Notifications" hideButton={false} />
            <NotificationListTable
                notifications={notifications}
                refresh={refresh}
            />
        </>
    );
}
